export const homeURL = `${process.env.REACT_APP_HOME}`;
export const loginURL = `${process.env.REACT_APP_LOGIN}`;

//
export const adminRoot = "/app";

// direction
export const defaultDirection = "rtl"; // rtl or ltr

// language
export const defaultLanguage = "fa";

// sidebar
export const defaultSidebarState = 2; // 0 == both is close , 1 == main is open, 2 == both is open;
export const defaultSidebarMainWidth = 90; // in pixels
export const defaultSidebarSubWidth = 240; // in pixels
export const moveBoth = false; // false , true
export const mainMenuHasPage = false; // false , true --- by clicking on mainMenu items shows a new page or not

// header
export const defaultHeaderHeight = 60; // in pixels

// orders

export const orderStatusOptions = [
    {
        value: "failed",
        label: "ناموفق"
    },
    {
        value: "on-hold",
        label: "در انتظار بررسی"
    },
    {
        value: "processing",
        label: "در حال انجام"
    },
    {
        value: "pws-packaged",
        label: "بسته بندی شده"
    },
    {
        value: "cancelled",
        label: "لغو شده"
    },
    {
        value: "pws-post",
        label: "تحویل پست"
    },
    {
        value: "pws-courier",
        label: "تحویل پیک"
    },
    {
        value: "completed",
        label: "تکمیل شده"
    },
    {
        value: "completed-service",
        label: "(خدمات) تکمیل شده"
    },
    {
        value: "pending",
        label: "در انتظار پرداخت"
    },
    {
        value: "refunded",
        label: "مسترد شده"
    },
]

export const completedStatuses = "pws-post,completed,completed-service,pws-courier,pws-packaged"; // precompleted + completed

export const expressShippingTitle = "ارسال اکسپرس بدورژ"